import { render, staticRenderFns } from "./use-withdrawal.vue?vue&type=template&id=655f3e9f&scoped=true&"
import script from "./use-withdrawal.vue?vue&type=script&lang=js&"
export * from "./use-withdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f3e9f",
  null
  
)

export default component.exports